import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useNavigate } from 'react-router-dom';

type RowsProps = {
  item: any;
};

const Rows: React.FC<RowsProps> = (props) => {
  const navigate = useNavigate();
  const dataRow = props.item;

  const handleRowClick = () => {
    navigate(`/user/view?id=${dataRow.userid}`);
  };

  return (
    <TableRow
      hover
      sx={{
        '&:last-child td, &:last-child th': { border: 0 },
        cursor: 'pointer',
      }}
      onClick={handleRowClick}
    >
      <TableCell>{dataRow.fullname}</TableCell>
      <TableCell>{dataRow.username}</TableCell>
      <TableCell>{dataRow.role}</TableCell>
      <TableCell>{dataRow.lastlogintime}</TableCell>
      <TableCell>{dataRow.alias}</TableCell>
      <TableCell>{dataRow.displayorder}</TableCell>
      <TableCell>{dataRow.status === '1' ? '有効' : '無効'}</TableCell>
    </TableRow>
  );
};

export default Rows;
